import { createContext, useContext, useState, ReactNode } from 'react'
import { Scenario } from '../components/ScenarioControls'

interface ScenarioContextType {
  // Simulation workflow state
  activeSimulationScenario: Scenario | null
  setActiveSimulationScenario: (scenario: Scenario | null) => void
  
  // Validation workflow state
  activeValidationScenario: Scenario | null
  setActiveValidationScenario: (scenario: Scenario | null) => void
  
  // General state
  isValidationScenarioActive: boolean
  currentScenario: Scenario | null
}

const ScenarioContext = createContext<ScenarioContextType | undefined>(undefined)

export const useScenario = () => {
  const context = useContext(ScenarioContext)
  if (context === undefined) {
    throw new Error('useScenario must be used within a ScenarioProvider')
  }
  return context
}

interface ScenarioProviderProps {
  children: ReactNode
}

export const ScenarioProvider: React.FC<ScenarioProviderProps> = ({ children }) => {
  const [activeSimulationScenario, setActiveSimulationScenario] = useState<Scenario | null>(null)
  const [activeValidationScenario, setActiveValidationScenario] = useState<Scenario | null>(null)

  const isValidationScenarioActive = !!activeValidationScenario
  const currentScenario = activeValidationScenario || activeSimulationScenario

  const value: ScenarioContextType = {
    activeSimulationScenario,
    setActiveSimulationScenario,
    activeValidationScenario,
    setActiveValidationScenario,
    isValidationScenarioActive,
    currentScenario
  }

  return (
    <ScenarioContext.Provider value={value}>
      {children}
    </ScenarioContext.Provider>
  )
}

export default ScenarioContext
